import { graphql, useStaticQuery } from "gatsby";
import BackgroundImage from "gatsby-background-image";
import { StaticImage } from "gatsby-plugin-image";
import { ScrollAnimation } from "~/components/shared/ScrollAnimation";
import * as styles from "./style";

export const Gallery = () => {
  const { background } = useStaticQuery<GatsbyTypes.GalleryQuery>(
    graphql`
      query Gallery {
        background: file(relativePath: { eq: "btn-background.png" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 320) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );
  return (
    <div css={styles.gallery}>
      <ul css={styles.items}>
        <li css={styles.item}>
          <ScrollAnimation>
            <StaticImage
              src={"../../../images/img_design1.png"}
              alt={""}
              width={956}
              height={611}
            />
          </ScrollAnimation>
        </li>
        <li css={styles.item}>
          <ScrollAnimation>
            <StaticImage
              src={"../../../images/img_design2.png"}
              alt={""}
              width={956}
              height={611}
            />
          </ScrollAnimation>
        </li>
        <li css={styles.item}>
          <ScrollAnimation>
            <StaticImage
              src={"../../../images/img_design3.jpg"}
              alt={""}
              width={956}
              height={611}
            />
          </ScrollAnimation>
        </li>
        <li css={styles.item}>
          <ScrollAnimation>
            <StaticImage
              src={"../../../images/img_design4.jpg"}
              alt={""}
              width={956}
              height={611}
            />
          </ScrollAnimation>
        </li>
      </ul>
      <div css={styles.serviceButtonWrapper}>
        <a
          css={styles.serviceButton}
          href="https://whowatch.tv/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BackgroundImage
            fluid={background?.childImageSharp?.fluid}
            style={{ backgroundPosition: "center", backgroundSize: "cover" }}
          >
            <div css={styles.serviceButtonInner}>ふわっち サービスサイトへ</div>
          </BackgroundImage>
        </a>
      </div>
    </div>
  );
};
